@use '~/theme/theme' as *;

.progressBar {
  height: 4px;
  background-color: color(grey-500);
  width: 100%;
  overflow: hidden;
}

.progressBarValue {
  width: 100%;
  height: 100%;
  background-color: color(grey-800);
  animation: indeterminate-animation 1s infinite linear;
  transform-origin: 0% 50%;
}

@keyframes indeterminate-animation {
  0% {
    transform: translateX(0) scaleX(0);
  }

  40% {
    transform: translateX(0) scaleX(0.4);
  }

  100% {
    transform: translateX(100%) scaleX(0.5);
  }
}
